export const getServerConfiguration = state => state.config;
